import { useLocation } from "react-router-dom";
import FormSkeleton from "./FormSkeleton";
import AdminSkeleton from "./AdminSkeleton";
import AuthSkeleton from "./AuthSkeleton";
import LegalPageSkeleton from "./LegalPageSkeleton";
import HomeSkeleton from "./HomeSkeleton";
import PageSkeleton from "../PageSkeleton";

const formRoutes = [
  "/extras-carte-funciara",
  "/contact",
];

const adminRoutes = [
  "/admin",
];

const authRoutes = [
  "/auth",
  "/login",
  "/register",
];

const legalRoutes = [
  "/termeni-si-conditii",
  "/politica-confidentialitate",
  "/despre-noi",
  "/solutionare-litigii",
];

// Check if path starts with any of the patterns
const matchesPattern = (path: string, patterns: string[]) => {
  return patterns.some((pattern) => path === pattern || path.startsWith(pattern + "-"));
};

export const RouteAwareSkeleton = () => {
  const location = useLocation();
  const path = location.pathname;

  // Home page
  if (path === "/") {
    return <HomeSkeleton />;
  }

  // Admin pages
  if (matchesPattern(path, adminRoutes)) {
    return <AdminSkeleton />;
  }

  // Auth pages
  if (matchesPattern(path, authRoutes)) {
    return <AuthSkeleton />;
  }

  // Legal pages
  if (matchesPattern(path, legalRoutes)) {
    return <LegalPageSkeleton />;
  }

  // Form/order pages
  if (matchesPattern(path, formRoutes)) {
    return <FormSkeleton />;
  }

  // Default skeleton
  return <PageSkeleton />;
};

export { FormSkeleton, AdminSkeleton, AuthSkeleton, LegalPageSkeleton, HomeSkeleton };
export default RouteAwareSkeleton;
